<template>
  <div>
    <h4 class="font-bold mt-4">{{ $t('current_params') }}</h4>
    <table>
      <tr class="mt-1">
        <th>{{$t('frequency')}}</th>
        <td class="mt-1"><input v-model="mode_param.frequency"
                                 @input="validateFrequency"
                                type="number" min="2" max="240">{{$t('minuts')}}</td>
      </tr>
      <tr>
        <th>{{$t('alarm')}}</th>
        <td><input type="checkbox" v-model="mode_param.alarm"></td>
      </tr>
      <tr>
        <th>{{$t('smart_alarm')}}</th>
        <td><input type="checkbox" v-model="mode_param.smart_alarm"></td>
      </tr>
      <tr v-if="mode_param.requested_mode">
        <th>{{$t('pending_mode')}}</th>
        <td>{{ $t('yes')}} ({{ mode_param.requested_mode }})</td>
      </tr>
    </table>
    <button type="submit" class="btn btn-primary" @click="changeMode">{{ $t('request_mode') }}</button>
  </div>
</template>
<script>
import * as nvxlib from "@/nvxcommon";
import {changeModeParam} from "@/nvxcommon";

export default {
  name: 'TrackerChangeMode',
  data: function () {
    return {
      mode_param: {
        'frequency': undefined,
        'alarm': undefined,
        'smart_alarm': undefined
      }
    }
  },
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {},
  methods: {
    validateFrequency() {
      if (this.mode_param.frequency < 2) {
        this.mode_param.frequency = 2;
      }
      if (this.mode_param.frequency > 240) {
        this.mode_param.frequency = 240;
      }
    },
    changeMode() {
      const self = this;
      let params = this.mode_param;
      nvxlib.changeModeParam(this.device, params, function (mode_param) {
        console.log("mode_param", mode_param);
        self.mode_param = mode_param;
      });
    },

    fmtDate(date) {
      return nvxlib.fmtDate(date);
    }
  },
  mounted() {
    const self = this;
    nvxlib.getModeParam(this.device, function (mode_param) {
      self.mode_param = mode_param;
    });
  }

}
</script>